var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { WebKitNativeNotifications } from "./WebKit/NativeNotifications";
import { CommonService } from "../Common/CommonService";
import { NativeContext } from "../Common/ICommonService";
export class NotificationsService {
    GetServiceName() {
        return NotificationsService.ServiceName;
    }
    GetDeviceFirebaseTokenAsync() {
        return __awaiter(this, void 0, void 0, function* () {
            switch (yield CommonService.GetNativeContextAsync()) {
                case NativeContext.AndroidGecko:
                    return navigator.AndroidNotifications.GetDeviceFirebaseTokenAsync();
                case NativeContext.IosWebkit:
                    return yield WebKitNativeNotifications.GetDeviceFirebaseTokenAsync();
                default:
                    return null;
            }
        });
    }
    CheckNotificationPermissionAsync() {
        return __awaiter(this, void 0, void 0, function* () {
            switch (yield CommonService.GetNativeContextAsync()) {
                case NativeContext.AndroidGecko:
                    return navigator.AndroidNotifications.CheckNotificationPermissionAsync();
                case NativeContext.IosWebkit:
                    return yield WebKitNativeNotifications.GetNativeNotificationsPermissionAsync();
                default:
                    return false;
            }
        });
    }
    GetNotificationsQueueAsync() {
        return __awaiter(this, void 0, void 0, function* () {
            switch (yield CommonService.GetNativeContextAsync()) {
                case NativeContext.AndroidGecko:
                    return navigator.AndroidNotifications.GetNotificationsQueueAsync();
                case NativeContext.IosWebkit:
                    return yield WebKitNativeNotifications.GetNativeNotificationsQueueAsync();
                default:
                    throw new Error("Notifications queue is not supported in this context.");
            }
        });
    }
}
NotificationsService.ServiceName = "NotificationsService";
//# sourceMappingURL=NotificationService.js.map